module.exports = __webpack_public_path__ + "img/jz-bg.a1169338.png";